import * as Styled from './UISpinner.styled'

export function UISpinner() {
  return (
    <Styled.SpinnerContainer>
      <Styled.Spinner />
    </Styled.SpinnerContainer>
  )
}
